import types from "./actionTypes";
import { dealWithClusterletConnections } from '../../undoredo/actions'
import { getClusterlets } from '../clusterlets/selectors'

const shortUUid = require("short-uuid");



export const addClusterletConnection = (payload, noUndoRedo, connectedTemplate) => (dispatch) => {

    if (noUndoRedo != true) dispatch(dealWithClusterletConnections({ item: payload, connectedTemplate: connectedTemplate }, 'add'))

    dispatch({
        type: types.ADD_CLUSTERLET_CONNECTION,
        payload,
    })
};


export const deleteClusterletConnection = (payload, noUndoRedo) => (dispatch) => {

    const { item, connetedTemplate } = payload;

    ['selected', 'style', 'zIndex', 'animated'].forEach(e => { if (item[e]) delete item[e] });


    if (noUndoRedo != true) dispatch(dealWithClusterletConnections({ item, connetedTemplate }, 'delete'))

    dispatch({
        type: types.DELETE_CLUSTERLET_CONNECTION,
        payload: item,
    })
};


export const onConnect = (params) => (dispatch, getState) => {

    const { item, connectedTemplate } = params;

    const elements = getClusterlets(getState());


    const connection = {
        ...item,
        id: shortUUid.generate()
    }

    dispatch(addClusterletConnection(connection, undefined, connectedTemplate));

};

export const updateFullClusterletConnections = (connections) => ({
    type: types.UPDATE_FULL_CLUSTERLET_CONNECTIONS,
    payload: connections
})

/** Create connection between two nodes */
export const connectNodes = (source, destination) => (dispatch, getState) => {

}

export const resetClusterletConnections = (connections) => ({
    type: types.RESET_CLUSTERLET_CONNECTIONS,
    payload: connections
})


export const editClusterletConnection = (payload) => (dispatch) => {

    dispatch({
        type: types.EDIT_CLUSTERLET_CONNECTION,
        payload,
    })
};
